import createSimpleComponent from '../createSimpleComponent'

import cls from './tab.module.scss'

export default createSimpleComponent({
  displayName: 'TabContainer',
  className: cls.container,
  Component: 'div',
})
